import { RenderTiles } from '../../components/common';

import { CgSmartHomeWashMachine } from 'react-icons/cg';
import { GiVendingMachine } from 'react-icons/gi';

const tilesObj = [
  {
    sNo: 2,
    link: '/common/MachineCheckSheetList?document_type=mechanical',
    isLink: true,
    icon: <GiVendingMachine size="5rem" color="#003566" />,
    p: 'MECHANICAL',
    span: '',
    isIcon: true,
  },
  {
    sNo: 8,
    link: '/common/MachineCheckSheetList?document_type=pnumetic',
    isLink: true,
    icon: <CgSmartHomeWashMachine size="5rem" color="#003566" />,
    p: 'PNUMETIC',
    span: '',
    isIcon: true,
  },
];

const Home = () => {
  return (
    <RenderTiles
      tilesObj={tilesObj}
      height="100vh"
      justify="start"
      columns="0fr"
    />
  );
};

export default Home;
